import { registerPlugin } from '@capacitor/core';
import { runtime } from './runtime';
export const secureSessionPlugin = registerPlugin('SecureSession');
export const isBiometricLock = error => typeof error?.code === 'string' && error.code.startsWith('BIOMETRIC_');
let automaticAttempted = false;
let suppressed = false;
const resumeListeners = new Set();
export const biometrics = {
    claimAutomaticLogin: () => {
        if (suppressed || automaticAttempted) return false;
        automaticAttempted = true; return true;
    },
    didLogin: () => { automaticAttempted = false; suppressed = false; },
    suppressAutomaticLogin: () => { suppressed = true; },
    credentialsCleared: () => {
        suppressed = true;
        // Logout can mount the login screen before secure deletion completes.
        // Refresh its status without requesting an automatic biometric login.
        for (const callback of resumeListeners) callback();
    },
    resumed: () => { suppressed = false; automaticAttempted = false; for (const callback of resumeListeners) callback(); },
    onAutomaticLogin: callback => { resumeListeners.add(callback); return () => resumeListeners.delete(callback); },
    status: () => runtime.isNative() ? secureSessionPlugin.biometricStatus() : Promise.resolve({ available: false, enabled: false, label: 'Biometrics' }),
    enable: () => secureSessionPlugin.enableBiometrics(),
    disable: async () => {
        const { authStorage } = await import('./storage');
        try { await authStorage.clearAuth(); }
        catch (error) {
            if (!isBiometricLock(error)) throw error;
            // One-time migration for saved sign-in from older native builds.
            await secureSessionPlugin.unlock();
            await authStorage.clearAuth();
        }
        suppressed = true;
    },
    lock: () => secureSessionPlugin.lock(),
    unlock: async () => {
        await secureSessionPlugin.unlock();
        const { authStorage } = await import('./storage');
        await authStorage.renewAfterUnlock();
    },
    onResume: callback => secureSessionPlugin.addListener('resumed', callback),
};
